import { createRestSlice } from "./restSlice";

export type OrganizationSnippet = {
  id: string;
  organizationId: string;
  type: string;
  name: string;
  data: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};

const organizationSnippetSlice = createRestSlice<OrganizationSnippet>("organizationSnippets", "/v1/organization-snippets");

export const organizationSnippetReducer = organizationSnippetSlice.reducer;
export const organizationSnippetActions = organizationSnippetSlice.actions;
